type WithPartNumber = { partNumber: string };

function hasPartNumber(obj: unknown): obj is WithPartNumber {
    return typeof obj === 'object' && obj !== null && typeof (obj as any).partNumber === 'string';
}

/**
 * Filters a raw inbound payload to an array of objects that contain at least
 * a `partNumber: string` field. Malformed entries are logged and skipped.
 */
export function validatePartnrPayload<T extends WithPartNumber>(
    data: unknown,
    connectorName: string,
): T[] {
    if (!Array.isArray(data)) return [];
    const valid: T[] = [];
    for (const item of data) {
        if (hasPartNumber(item)) {
            valid.push(item as T);
        } else {
            console.warn(`[${connectorName}]: Ignoring malformed part entry:`, item);
        }
    }
    return valid;
}
